import { find, includes, isEmpty, keys, some } from 'lodash/fp';
import { FormikErrors } from 'formik';

import { ModalField } from '../../types';

type GetPanelIndexForErrorParams<T> = {
  errors: FormikErrors<T>;
  modalFields: ModalField[];
};

const getPanelIndexForError = <T>({ modalFields, errors }: GetPanelIndexForErrorParams<T>) => {
  const errorFields = keys(errors);
  if (isEmpty(errorFields)) {
    return null;
  }

  const matchingPanel = find(({ fields }) => some((field) => includes(field, fields), errorFields), modalFields);
  if (!matchingPanel) {
    return null;
  }
  return matchingPanel.index;
};

export default getPanelIndexForError;
